import { r as registerInstance, h } from './index-16dc7dde.js';

const uscCss = ":host{display:block;box-sizing:border-box;z-index:10}:host *,:host *::before,:host *::after{box-sizing:inherit}:host ::slotted(*){margin-bottom:12px;pointer-events:all}:host ::slotted(*:last-child:not(pes-back-to-top)){margin-bottom:0}.usc-wrapper{display:flex;flex-direction:column;justify-content:flex-end;align-items:flex-end;pointer-events:none;width:100%;position:fixed;right:0;bottom:0;left:0;z-index:9;margin-bottom:12px}@media screen and (max-width: 719px){.usc-wrapper{padding:0;margin-bottom:0}}@media screen and (min-width: 720px){.usc-wrapper{margin-bottom:12px}}";

let Usc = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return (h("div", { class: "usc-wrapper" }, h("slot", null)));
  }
};
Usc.style = uscCss;

export { Usc as pes_usc };
